<app-loading [pequeno]="true" *ngIf="cargando"></app-loading>

<ng-container *ngIf="!cargando">
  <p-accordion id="accordionTopesInversion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
    <p-accordionTab header="{{ 'TOPESINVERSION.LBL_TOPESCANAL' | translate }}"
                    [selected]="tabSeleccionado === 'CAN'">
      <div class="grid">
        <div class="col-12">
          <form [formGroup]="formularioCanal" novalidate>
            <div class="grid form-group">
              <!-- Canal -->
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ 'TOPESINVERSION.LBL_CANAL' | translate }}:</label>
                  <p-dropdown id="idCanal" name="idCanal" placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                              formControlName="idCanal" [options]="listaCanales"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value" optionLabel="label"
                  ></p-dropdown>

                  <div class="p-message p-messages-error p-corner-all" *ngIf="submittedCanal && fc.idCanal.invalid">
                    {{ 'TOPESINVERSION.LBL_CANAL' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>
              <!-- Monto minimo -->
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ 'TOPESINVERSION.LBL_MONTOMINIMO' | translate }}:</label>
                  <input type="text" pInputText id="montoMinimo" name="montoMinimo"
                         formControlName="montoMinimo"
                         autocomplete="off"
                         [maxlength]="15"
                         currencyMask
                         [options]="currencyMaskOptions">

                  <div class="p-message p-messages-error p-corner-all">
                    <ng-container *ngIf="submittedCanal && fc.montoMinimo.errors?.required">
                      {{ 'TOPESINVERSION.LBL_MONTOMINIMO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                    </ng-container>

                    <ng-container *ngIf="submittedCanal && !fc.montoMinimo.errors?.required && formularioCanal.errors?.rangeSequence">
                      {{ 'TOPESINVERSION.LBL_MONTOMINIMO' | translate }} {{ 'TOPESINVERSION.LBL_MENOR_A' | translate }} {{ 'TOPESINVERSION.LBL_MONTOMAXIMO' | translate }}
                    </ng-container>
                  </div>
                </div>
              </div>
              <!-- Monto maximo -->
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ 'TOPESINVERSION.LBL_MONTOMAXIMO' | translate }}:</label>
                  <input type="text" pInputText id="montoMaximo" name="montoMaximo"
                         formControlName="montoMaximo"
                         autocomplete="off"
                         [maxlength]="15"
                         currencyMask
                         [options]="currencyMaskOptions">

                  <div class="p-message p-messages-error p-corner-all">
                    <ng-container *ngIf="submittedCanal && fc.montoMaximo.errors?.required">
                      {{ 'TOPESINVERSION.LBL_MONTOMAXIMO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                    </ng-container>

                    <ng-container *ngIf="submittedCanal && !fc.montoMaximo.errors?.required && formularioCanal.errors?.rangeSequence">
                      {{ 'TOPESINVERSION.LBL_MONTOMAXIMO' | translate }} {{ 'TOPESINVERSION.LBL_MAYOR_A' | translate }} {{ 'TOPESINVERSION.LBL_MONTOMINIMO' | translate }}
                    </ng-container>
                  </div>
                </div>
              </div>
              <!-- Plazo minimo -->
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ 'TOPESINVERSION.LBL_PLAZOMINIMO' | translate }}:</label>
                  <input type="text" pInputText id="plazoMinimo" name="plazoMinimo" autocomplete="off"
                         [minimo]="1"
                         formControlName="plazoMinimo" numero-entero-reactive [maxlength]="4" (blur)="validarPlazos()">

                  <div class="p-message p-messages-error p-corner-all">
                    <ng-container *ngIf="submittedCanal && fc.plazoMinimo.invalid">
                      {{ 'TOPESINVERSION.LBL_PLAZOMINIMO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                    </ng-container>

                    <ng-container *ngIf="!rangoMininoValido">
                      {{ 'TOPESINVERSION.MSG_ERRORRANGOPLAZO' | translate }}
                    </ng-container>
                  </div>
                </div>
              </div>
              <!-- Plazo maximo -->
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ 'TOPESINVERSION.LBL_PLAZOMAXIMO' | translate }}:</label>
                  <input type="text" pInputText id="plazoMaximo" name="plazoMaximo" autocomplete="off"
                         [minimo]="1"
                         formControlName="plazoMaximo" numero-entero-reactive [maxlength]="4" (blur)="validarPlazos()">

                  <div class="p-message p-messages-error p-corner-all" *ngIf="submittedCanal && fc.plazoMaximo.invalid">
                    {{ 'TOPESINVERSION.LBL_PLAZOMAXIMO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>
              <!-- Indicador habilitado -->
              <div class="col-12 md:col-4 lg:col-4 mt-3">
                <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                            id="indicadorHabilitado" name="indicadorHabilitado"
                            formControlName="indicadorHabilitado"></p-checkbox>
              </div>
            </div>
            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <ng-container *ngIf="!guardandoCanal">
                  <a (click)="regresar(formularioCanal.dirty)" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-plus" label="{{(idTopeCanal ? 'BTN_ACTUALIZAR' : 'BTN_GUARDAR') | translate }}"
                          type="button" (click)="agregarTope()" pButton></button>
                </ng-container>
                <app-loading [pequeno]="true" *ngIf="guardandoCanal"></app-loading>
              </div>
            </div>
          </form>
        </div>
      </div>
    </p-accordionTab>

    <p-accordionTab header="{{ 'TOPESINVERSION.LBL_PAGOINTERESES' | translate }}"
                    [selected]="tabSeleccionado === 'INT'" [disabled]="!idTopeCanal">
      <div class="grid">
        <div class="col-12">
          <form [formGroup]="formularioFrecuencia" novalidate>
            <div class="grid form-group">
              <!-- Frecuencia -->
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ 'TOPESINVERSION.LBL_FRECUENCIAPAGO' | translate }}:</label>
                  <p-dropdown id="idFrecuenciasProductos" name="idFrecuenciasProductos"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                              formControlName="idFrecuenciasProductos"
                              [options]="lisFrecuenciasProductos"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value" optionLabel="label"
                  ></p-dropdown>

                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submittedFrecuencia && ff.idFrecuenciasProductos.invalid">
                    {{ 'TOPESINVERSION.LBL_FRECUENCIAPAGO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>
              <!-- Valor maximo -->
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ 'TOPESINVERSION.LBL_VALORMAXIMO' | translate }}:</label>
                  <input type="text" pInputText id="monto" name="monto" autocomplete="off" [minimo]="1"
                         formControlName="monto"
                         [maxlength]="10" numero-entero-reactive>

                  <div class="p-message p-messages-error p-corner-all" *ngIf="submittedFrecuencia && ff.monto.invalid">
                    {{ 'TOPESINVERSION.LBL_VALORMAXIMO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>
              <!-- Descripcion -->
              <div class="col-12 md:col-8 lg:col-8">
                <div class="div-form">
                  <label>* {{ 'TOPESINVERSION.LBL_DESCRIPCION' | translate }}:</label>
                  <input type="text" pInputText id="descripcion"
                         name="descripcion" autocomplete="off" formControlName="descripcion" maxlength="100">

                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submittedFrecuencia && ff.descripcion.invalid">
                    {{ 'TOPESINVERSION.LBL_DESCRIPCION' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>
              <!-- Indicador habilitado -->
              <div class="col-12 md:col-4 lg:col-4 mt-3">
                <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}"
                            binary="true" id="indicadorHabilitado" name="indicadorHabilitado"
                            formControlName="indicadorHabilitado"></p-checkbox>
              </div>
            </div>
            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <ng-container *ngIf="!guardandoFrecuencia">
                  <a (click)="cancelarFrecuencia(formularioFrecuencia.dirty)"
                     class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-plus" label="{{(frecuencia ? 'BTN_ACTUALIZAR' : 'BTN_AGREGAR') | translate }}"
                          type="button" (click)="agregarFrecuencia()" pButton></button>
                </ng-container>
                <app-loading [pequeno]="true" *ngIf="guardandoFrecuencia"></app-loading>
              </div>
            </div>
          </form>

          <p-table [columns]="columns" [loading]="loading" #dt
                   [value]="listadoFrecuencias" selectionMode="single" dataKey="idTopeCanalFrecuencia"
                   [paginator]="true" [rows]="10" paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                    class="text-center">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{ row.frecuencia }}</td>
                <td>{{ row.monto }}</td>
                <td>{{ row.descripcion }}</td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <div class="btn-group" role="group">
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil"
                            data-toggle="tooltip"
                            title="{{'BTN_EDITAR' | translate}}" pButton
                            (click)="editar(row)"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length">
                  {{ 'MSG_NOHAYREGISTROS' | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>

  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar(false)"></button>
    </div>
  </div>
</ng-container>

<p-confirmDialog #cd key="topes-canales">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog #rf key="topes-frecuencias">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="rf.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="rf.accept()"></button>
  </ng-template>
</p-confirmDialog>
